<template>
    <div class="flex justify-center">
        <paginate
            v-if="totalPages > 1"
            v-model="selected"
            :page-count="totalPages"
            :click-handler="eventDispatch"
            :prev-text="'Anterior'"
            :next-text="'Siguiente'"
            :active-class="'active-page'"
            :container-class="'pagination-container'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'nav-item'"
            :prev-link-class="'nav-link'"
            :next-class="'nav-item'"
            :next-link-class="'nav-link'"
            :disabled-class="'is-disabled'"
        >
            <template #prev>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
                <span class="hidden sm:inline">Anterior</span>
            </template>

            <template #next>
                <span class="hidden sm:inline">Siguiente</span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </template>
        </paginate>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Paginate,
    },
    data() {
        return {
            selected: this.currentPage || 1,
        };
    },
    props: {
        perPage: {
            type: Number,
            default: 15,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        totalRows: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        totalPages() {
            if (!this.totalRows || !this.perPage) return 0;
            return Math.max(1, Math.ceil(this.totalRows / this.perPage));
        },
    },
    watch: {
        currentPage(value) {
            const next = Number(value) || 1;
            if (this.selected !== next) {
                this.selected = next;
            }
        },
    },
    emits: ['updateParams'],
    methods: {
        eventDispatch(pageNum) {
            this.selected = pageNum;
            this.$emit('updateParams', pageNum);
        },
    },
};
</script>

<style scoped>
:deep(.pagination-container) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.375rem;
    list-style: none;
    padding: 0;
    margin: 0;
}

:deep(.page-item),
:deep(.nav-item) {
    list-style: none;
}

:deep(.page-link),
:deep(.nav-link) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    min-width: 36px;
    min-height: 36px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: #374151;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

:deep(.nav-link) {
    padding: 0 14px;
}

:deep(.page-link:hover),
:deep(.nav-link:hover) {
    background-color: #f9fafb;
    color: #f97316;
}

:deep(.active-page .page-link) {
    background-color: #f97316 !important;
    border-color: #f97316 !important;
    color: white !important;
    font-weight: 600 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

:deep(.is-disabled .nav-link) {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

:deep(.is-disabled .nav-link:hover) {
    background-color: white !important;
    color: #374151 !important;
}
</style>
